import React, { useEffect } from "react";

export default function SpotifyEmbed({ item }) {
  const [spotifyType, setSpotifyType] = React.useState("");

  const parseSpotifyPath = (str) => {
    if (typeof str !== "string") return null;
    const parts = str.split("/");
    if (parts.length !== 2) return null;
    if (parts[0].toLowerCase().trim() !== "spotify") return null;

    return parts[1].trim() || null;
  };

  useEffect(() => {
    const parsedType = parseSpotifyPath(item.type);
    setSpotifyType(parsedType);
  }, [item]);

  return (
    <div>
      <iframe
        title={item.title}
        src={
          "https://open.spotify.com/embed/" +
          spotifyType +
          "/" +
          item.filename +
          "?utm_source=generator"
        }
        width="100%"
        height="152"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        style={{ borderRadius: "12px" }}
        data-gtm-yt-inspected-8="true"
      ></iframe>
    </div>
  );
}
